import { HighlightText } from '@/components/common/HighlightText';
import { OPTION_DETAIL_SEPARATOR } from '@/utils/filters';
import { StackedCellText } from './StackedCellText';

interface MemberIdentity {
  name: string;
  hrEmpId: string | null;
  mobile: string | null;
}

interface MemberNameCellProps {
  member: MemberIdentity;
  searchText?: string | undefined;
}

export function MemberNameCell({ member, searchText }: MemberNameCellProps) {
  const detail = [member.hrEmpId, member.mobile].filter(Boolean).join(OPTION_DETAIL_SEPARATOR);

  return (
    <StackedCellText
      primary={<HighlightText text={member.name} highlightedText={searchText} />}
      primaryClassName="font-medium"
      secondary={detail && <HighlightText text={detail} highlightedText={searchText} />}
    />
  );
}
